<template>
    <v-dialog 
        v-model="show" 
        transition="dialog-top-transition"
        width="60%"
        :fullscreen="$vuetify.breakpoint.mobile"
    >
        <v-card>
            <v-card-title>
                <span class="headline">Send Email Template</span>
            </v-card-title>

            <v-divider></v-divider>

            <v-card-text>
                <v-container>
                    <!-- Customer Info Display -->
                    <v-row>
                        <v-col cols="12">
                            <v-alert type="info" outlined>
                                <strong>To:</strong> {{ customerName }} ({{ customerEmail }})
                            </v-alert>
                        </v-col>
                    </v-row>

                    <!-- Template Selection -->
                    <v-row>
                        <v-col cols="12">
                            <v-autocomplete
                                v-model="selectedTemplate"
                                :items="listTemplates"
                                item-text="templateDescription"
                                item-value="id"
                                label="Select Template"
                                outlined
                                dense
                                @change="loadTemplateContent"
                                :loading="loadingTemplates"
                            >
                                <template v-slot:item="{ item }">
                                    <div>
                                        <strong>{{ item.templateDescription }}</strong>
                                        <div style="font-size: 12px; color: #999;">
                                            {{ item.subject }}
                                        </div>
                                    </div>
                                </template>
                            </v-autocomplete>
                        </v-col>
                    </v-row>

                    <!-- Subject -->
                    <v-row v-if="selectedTemplate">
                        <v-col cols="12">
                            <v-text-field
                                v-model="emailData.subject"
                                label="Subject"
                                outlined
                                dense
                            ></v-text-field>
                        </v-col>
                    </v-row>

                    <!-- Email Content (Editable) -->
                    <v-row v-if="selectedTemplate">
                        <v-col cols="12">
                            <label class="required">Email Content</label>
                            <v-textarea
                                v-model="emailData.content"
                                outlined
                                rows="10"
                                counter
                            ></v-textarea>
                        </v-col>
                    </v-row>

                    <!-- Parameters Legend -->
                    <v-row>
                        <v-col cols="12">
                            <v-expansion-panels flat>
                                <v-expansion-panel>
                                    <v-expansion-panel-header class="pa-0" style="min-height: 36px;">
                                        <span style="font-size: 13px; color: #018388; font-weight: 600;">
                                            <v-icon small color="#018388" class="mr-1">mdi-information-outline</v-icon>
                                            Available Parameters — automatically replaced when sending
                                        </span>
                                    </v-expansion-panel-header>
                                    <v-expansion-panel-content>
                                        <v-simple-table dense class="parameters-legend">
                                            <thead>
                                                <tr>
                                                    <th>Parameter</th>
                                                    <th>Description</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="param in templateParameters" :key="param.key">
                                                    <td><code>{{ param.key }}</code></td>
                                                    <td>{{ param.description }}</td>
                                                </tr>
                                            </tbody>
                                        </v-simple-table>
                                    </v-expansion-panel-content>
                                </v-expansion-panel>
                            </v-expansion-panels>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions style="padding: 15px !important;">
                <div style="width: 100%; text-align: center;">
                    <v-btn
                        class="mx-2 dialogButtonDismiss v-btn-large"
                        outlined
                        @click="closeDialog"
                    >
                        Dismiss
                    </v-btn>
                    <v-btn
                        class="mx-2 v-btn-large"
                        outlined
                        :disabled="!selectedTemplate || !emailData.content"
                        @click="sendEmail"
                    >
                        Send Email
                    </v-btn>
                </div>
            </v-card-actions>

            <!-- <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="grey" text @click="closeDialog">
                    Cancel
                </v-btn>
                <v-btn
                    color="primary"
                    @click="sendEmail"
                    :loading="sending"
                    :disabled="!selectedTemplate || !emailData.content"
                >
                    Send Email
                </v-btn>
            </v-card-actions> -->
        </v-card>
    </v-dialog>
</template>

<script>
    import Helpers from '@/utilities/Helpers';

    export default {
        mixins: [Helpers],
        props: {
            dialogShow: {
                type: Boolean,
                required: true
            },
            idService: {
                type: Number,
                required: true
            },
            customerName: {
                type: String,
                required: true
            },
            customerEmail: {
                type: String,
                required: true
            }
        },
        
        data: () => ({
            show: false,
            listTemplates: [],
            selectedTemplate: null,
            emailData: {
                subject: '',
                content: ''
            },
            loadingTemplates: false,
            sending: false,

            templateParameters: [
                { key: '{fullCustomerName}',                description: 'Full customer name (e.g. Smith, John)' },
                { key: '{firstCustomerName}',               description: 'First name of the customer (e.g. John)' },
                { key: '{scheduledDate}',                   description: 'Appointment date (e.g. 04/15/2025)' },
                { key: '{scheduledTime}',                   description: 'Appointment time (e.g. 10:00 AM)' },
                { key: '{appointmentAddress}',              description: 'Address of the scheduled appointment' },
                { key: '{city}',                            description: 'City of the scheduled appointment' },
                { key: '{address}',                         description: 'Customer\'s home address with city' },
                { key: '{customerPhone}',                   description: 'Customer phone number' },
                { key: '{customerEmail}',                   description: 'Customer email address' },
                { key: '{userResponsibleFirstName}',        description: 'First name of the user responsible' },
                { key: '{userResponsibleLastName}',         description: 'Last name of the user responsible' },
                { key: '{userResponsibleEmail}',            description: 'Email of the user responsible' },
                { key: '{userResponsiblePhone}',            description: 'Phone number of the user responsible' },
                { key: '{vankirkInsta}',                    description: 'Van Kirk Instagram URL' },
                { key: '{vankirkFace}',                     description: 'Van Kirk Facebook URL' },
                { key: '{companyName}',                     description: 'Company Name' },
            ]
        }),

        watch: {
            dialogShow(val) {
                this.show = val;
                if (val) {
                    this.loadTemplates();
                }
            }
        },
        methods: {
            async loadTemplates() {
                this.loadingTemplates = true;
                try {
                    const templates = await this.$store.dispatch('templateEmailModule/List');
                    this.listTemplates = templates || [];
                } catch (error) {
                    console.error('Error loading templates:', error);
                    this.$store.dispatch('notificationModule/ShowNotification', {
                        message: 'Error loading email templates',
                        type: 'error'
                    });
                } finally {
                    this.loadingTemplates = false;
                }
            },

            async loadTemplateContent() {
                if (!this.selectedTemplate) return;

                try {
                    const template = this.listTemplates.find(t => t.id === this.selectedTemplate);
                    if (template) {
                        this.emailData.subject = template.subject || '';
                        this.emailData.content = template.description || '';
                    }
                } catch (error) {
                    console.error('Error loading template content:', error);
                }
            },

            async sendEmail() {
                if (!this.selectedTemplate || !this.emailData.content) {
                    this.$store.dispatch('notificationModule/ShowNotification', {
                        message: 'Please select a template and fill the email content',
                        type: 'warning'
                    });
                    return;
                }

                this.sending = true;
                try {
                    const payload = {
                        idService: this.idService,
                        idTemplateEmail: this.selectedTemplate,
                        subject: this.emailData.subject,
                        content: this.emailData.content,
                        customerEmail: this.customerEmail,
                        customerName: this.customerName
                    };

                    const result = await this.$store.dispatch('templateEmailModule/SendEmailToCustomer', payload);

                    if (result && result.success !== false) {
                        this.showToast("success", "Success!", 'Email sent successfully');
                        this.closeDialog();
                    } else {
                        this.showToast("error", "Warning!", 'Error sending email');
                    }
                } catch (error) {
                    console.error('Error sending email:', error);
                    this.showToast("error", "Warning!", 'Error sending email: ' + (error.message || ''));
                } finally {
                    this.sending = false;
                }
            },

            closeDialog() {
                this.selectedTemplate = null;
                this.emailData = {
                    subject: '',
                    content: ''
                };
                this.$emit('update:dialogShow', false);
            },
        }
    };
</script>

<style scoped>
    .required::after {
        content: '*';
        color: red;
        margin-left: 4px;
    }

    .parameters-legend code {
        background-color: #f0f0f0;
        padding: 2px 6px;
        border-radius: 4px;
        font-size: 12px;
        color: #018388;
    }
</style>
